export default {
      id: "accountability-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#accountability",
      toString: function () {
        return this.url;
      }
    }